import { useTheme } from "next-themes"
import * as React from "react"
import type { ToasterProps } from "sonner"
import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  // Tap anywhere on toast to dismiss
  React.useEffect(() => {
    const handler = (e: MouseEvent) => {
      const toastEl = (e.target as HTMLElement).closest("[data-sonner-toast]")
      if (!toastEl) return
      const closeBtn = toastEl.querySelector<HTMLButtonElement>(
        "[data-close-button]",
      )
      if (!closeBtn || closeBtn.contains(e.target as Node)) return
      closeBtn.click()
    }
    document.addEventListener("click", handler)
    return () => document.removeEventListener("click", handler)
  }, [])

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
